import { axiosAPI as axios } from 'utils';

const unwrap = (response) => response?.data || response || {};

export default {
  get() {
    return axios.get('/api/admin/mobile-push-settings').then(unwrap);
  },
  update(data) {
    return axios.put('/api/admin/mobile-push-settings', data).then(unwrap);
  },
  send(data) {
    return axios.post('/api/admin/mobile-push-settings/send', data).then(unwrap);
  },
  getHistory() {
    return axios.get('/api/admin/mobile-push-settings/history').then(unwrap);
  },
  deleteHistory(campaignId) {
    return axios.delete(`/api/admin/mobile-push-settings/history/${campaignId}`).then(unwrap);
  },
};
